import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { InvitedMember, InviteMembersError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  failedInvitations: { member: InvitedMember; error: InviteMembersError }[];
  inviteMembers(request: Boundaries["inviteMembers"]["request"]): void;
}

function useInviteMembers(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isInviteMembersRequestPending),
    isRequestSuccess: useSelector(selector.isInviteMembersRequestSuccess),
    isRequestFailure: useSelector(selector.isInviteMembersRequestFailure),
    failedInvitations: useSelector(selector.getFailedMemberInvitations),
    inviteMembers: core.inviteMembers,
  };
}

export { useInviteMembers };
